import { HttpClient } from '../HttpClient';
/**
 * * Get Client's Current Details
 */
export const GetClient = async () => {
  try {
    const { data } = await HttpClient.get('api/clients/current');

    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
